export const NAVIGATION_DIALOG = {
  DIALOG: 'navigation-dialog',
  DIALOG_TITLE: 'navigation-dialog-title',
  CLOSE_BUTTON: 'navigation-dialog-close-button',
  SEARCH_CLEAR_BUTTON: 'navigation-dialog-search-clear-button',
  TOAST_CLOSE_BUTTON: 'navigation-dialog-toast-close-button',
  CHANGE_DESTINATION_LINK: 'navigation-dialog-change-destination-link'
} as const;
